/**
 * @generated SignedSource<<e0a0fe189f90c91f66c8a47ac94988d5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { Url } from "@/common/relayCustomScalar";
export type InitUploadFileInput = {
  contentLength: number;
  contentType: string;
  filename: string;
};
export type FileUploadInitMutation$variables = {
  input: InitUploadFileInput;
};
export type FileUploadInitMutation$data = {
  readonly initUploadFile: {
    readonly key: string;
    readonly uploadUrl: Url;
  };
};
export type FileUploadInitMutation = {
  response: FileUploadInitMutation$data;
  variables: FileUploadInitMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InitUploadFile",
    "kind": "LinkedField",
    "name": "initUploadFile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uploadUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FileUploadInitMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "FileUploadInitMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "303b446608dd7a46dc3c82e6eae5a23e",
    "id": null,
    "metadata": {},
    "name": "FileUploadInitMutation",
    "operationKind": "mutation",
    "text": "mutation FileUploadInitMutation(\n  $input: InitUploadFileInput!\n) {\n  initUploadFile(input: $input) {\n    key\n    uploadUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7e20daee5c4ca68910b4a6e7f673836";

export default node;
